// import React from "react";
import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import "./coaching.css";
import ContactPhoneRoundedIcon from "@mui/icons-material/ContactPhoneRounded";
import AttachEmailRoundedIcon from "@mui/icons-material/AttachEmailRounded";
const Coaching = () => {
  return (
    <>
 


      <div
        id="rs-latest-news-style7"
        className="rs-latest-news-style7 sec-spacer"
      >
        <div className="container ">
          <div className=" ">
            <h2 className="title text-center pb-50 md-pb-30  mt-2 ">
              📚 Our{" "}
              <strong style={{ color: "#f7b205" }}>
                INSTITUTE or COACHING
              </strong>
            </h2>

            <div className="row " style={{ marginTop: "30px" }}>
              {/* Creative Card 1 */}
              <div className="col-lg-6 col-md-12">
                <div className="creative-card">
                  <div className="badge">Top Rated Coaching</div>
                  <img
                    src="assetsfront/images/coaching2.jpg"
                    alt="Success Coaching"
                  />
                  <div className="creative-content">
                    <div className="creative-title">
                      {" "}
                      🏫 Vedanta Ias Academy
                    </div>
                    <p style={{ fontStyle: "italic" }}>
                      "Prepare for India's most prestigious examinations with
                      expert faculty, personalized mentorship, and structured
                      learning programs. Whether it's UPSC Civil Services, IAS,
                      or State Public Service Commission exams, we help you turn
                      your dreams into reality."
                    </p>
                    <div className="row">
                      {/* Creative Card 1 */}
                      <div className="col-lg-6 col-md-12">
                        <div className="creative-courses">
                          Courses: UPSC, IAS, State Exams
                        </div>
                        <div className="creative-location">
                          Location: Rohini,Delhi India
                        </div>
                      </div>

                      {/* Creative Card 1 */}
                      <div className="col-lg-6">
                        <div className="creative-courses">
                          <ContactPhoneRoundedIcon /> Enquire Now:{" "}
                          <a href="tel:9911753333">9911753333</a>
                        </div>
                        <div className="creative-location">
                          <AttachEmailRoundedIcon /> Mail:{" "}
                          <a href="mailto:vedantaiasacademy@gmail.com">
                            vedantaiasacademy@gmail.com
                          </a>
                        </div>
                      </div>
                    </div>

                    <Link to={"/studentregister"} className="enroll-btn">
                      Enroll Now
                    </Link>
                  </div>
                </div>
              </div>
              {/* Creative Card 2 */}
              <div className="col-lg-6 col-md-12">
                <div className="creative-card">
                  <div className="badge">New Batch</div>
                  <img
                    src="assetsfront/images/coaching1.jpg"
                    alt="Achiever's Academy"
                  />
                  <div className="creative-content">
                    <div className="creative-title"> 🏫 Afte Institute</div>
                    <p style={{ fontStyle: "italic" }}>
                      "Specialized coaching for B.Ed, M.Ed, D.El.Ed programs
                      along with focused preparation for TGT, PGT, and TRT
                      recruitment exams. Empower your teaching career with
                      expert training and comprehensive study material."
                    </p>

                    <div className="row">
                      {/* Creative Card 1 */}
                      <div className="col-lg-6">
                        <div className="creative-courses">
                          Courses: :B.Ed ,M.Ed ,D.El.Ed
                        </div>
                        <div className="creative-location">
                          Location: Rohini,Delhi India
                        </div>
                      </div>

                      {/* Creative Card 1 */}
                      <div className="col-lg-6">
                        <div className="creative-courses">
                          <ContactPhoneRoundedIcon /> Enquire Now:{" "}
                          <a href="tel:9911103333">9911103333</a>
                        </div>
                        <div className="creative-location">
                          <AttachEmailRoundedIcon /> Mail:{" "}
                          <a href="mailto:afte97@gmail.com">afte97@gmail.com</a>
                        </div>
                      </div>
                    </div>

                    <Link to={"/studentregister"} className="enroll-btn">
                      Enroll Now
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Coaching;
